import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

// The router keeps the previous page's scroll offset; start every page at the top.
// Only path changes count — query-string changes (pagination, filters) are handled by the pages.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
